// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tZSnX","disabled":"styles_disabled__1iHws"};